module.exports = __webpack_public_path__ + "static/yellowpaper_zh-7e08aeebb1283cfb0925c8ebabc79c3b.pdf";